import React from 'react';
import './GenericTableSkeleton.css';

const GenericTableSkeleton = ({ columns = 7, rows = 10, columnTypes = [], className = '' }) => {
  const defaultColumnTypes = Array.from({ length: columns }, (_, i) => {
    if (columnTypes[i]) return columnTypes[i];
    return 'cell';
  });

  const getSkeletonClass = type => {
    switch (type) {
      case 'badge':
        return 'generic-skeleton-badge';
      case 'cell-long':
        return 'generic-skeleton-line md';
      case 'cell-short':
        return 'generic-skeleton-line sm';
      case 'cell-xs':
        return 'generic-skeleton-line xs';
      case 'cell-lg':
        return 'generic-skeleton-line lg';
      default:
        return 'generic-skeleton-line sm';
    }
  };

  return (
    <div className={`generic-table-skeleton ${className}`}>
      <div className="generic-table-skeleton-thead">
        {Array.from({ length: columns }).map((_, idx) => (
          <div key={idx} className="generic-table-skeleton-th" />
        ))}
      </div>
      <div className="generic-table-skeleton-tbody">
        {Array.from({ length: rows }).map((_, rowIdx) => (
          <div key={rowIdx} className="generic-table-skeleton-tr">
            {defaultColumnTypes.map((type, colIdx) => (
              <div key={colIdx} className="generic-table-skeleton-td">
                <div className={getSkeletonClass(type)} />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default GenericTableSkeleton;
